<template>
  <div style='box-shadow: 12px 13px 10px #1e3456;height:800px'>
    <div class="totalPie">
      <div class="tit">
        <p>本月巡查统计</p>
      </div>
      <div class="Piebar" id="xcbar"></div>
    </div>
    <div class="zrrlist">
      <div class="tit">
        <p>本年隐患统计</p>
      </div>
      <div class="Piebar" id="yhbar"></div>
    </div>
  </div>
</template>

<script>
  import {
    totalForXc,
    totalForYh
  } from "@/api/api";
  import "../../common/css/list.css";
  export default {
    data() {
      return {
        xcCityName: [],
        xcCityId: [],
        xctjNum: [],

        yhCityName: [],
        yhCityId: [],
        sum: [],
        solveSum: [],
        noSolveSum: [],
      };
    },
    components: {
    },
    mounted() {},
    computed: {
      nowxingzhengCodes() {
        return this.$store.state.nowxingzhengCode; //需要监听的数据
      },
      myydbDataFuns() {
        return this.$store.state.myydbData; //需要监听的数据
      },
    },
    watch: {
      nowxingzhengCodes(newVal, oldVal) {
        // console.log(newVal)
        let params;
        if (this.$store.state.ydbryorssShow == false) {
          params = {
            regionCode: newVal
          };
        } else {
          params = {
            regionCode: newVal,
            ydbCodeList: this.$store.state.myydbData
          };
        }
        this.totalForXcFun(params);
        this.totalForYhFun(params);
      },
      myydbDataFuns(newVal, oldVal) {
        let params;
        if (this.$store.state.ydbryorssShow == false) {
          params = {
            regionCode: this.$store.state.nowxingzhengCode
          };
        } else {
          params = {
            regionCode: this.$store.state.nowxingzhengCode,
            ydbCodeList: newVal
          };
        }
        this.totalForXcFun(params);
        this.totalForYhFun(params);
      }
    },
    methods: {
      //巡查维护巡查统计，全局
      totalForXcFun(params) {
        totalForXc(params).then((res) => {
          // console.log(res)
          this.xcCityName = [];
          this.xcCityId = [];
          this.xctjNum = [];
          for (let i = 0; i < res.data.length; i++) {
            this.xcCityName.push(res.data[i].cityName);
            // this.xcCityId.push(res.data[i].cityCode);
            this.xcCityId.push({
              code: res.data[i].cityCode,
              name: res.data[i].cityName
            });
            this.xctjNum.push(Number(res.data[i].sum));
          }
          this.xctjFun(this.xcCityName, this.xcCityId, this.xctjNum);
        });
      },
      //巡查维护隐患统计，全局
      totalForYhFun(params) {
        totalForYh(params).then((res) => {
          // console.log(res)
          this.yhCityName = [];
          this.yhCityId = [];
          this.sum = [];
          this.solveSum = [];
          this.noSolveSum = [];
          for (let i = 0; i < res.data.length; i++) {
            this.yhCityName.push(res.data[i].cityName);
            // this.yhCityId.push(res.data[i].cityCode);
            this.yhCityId.push({
              code: res.data[i].cityCode,
              name: res.data[i].cityName
            });
            this.sum.push(Number(res.data[i].sum));
            this.solveSum.push(Number(res.data[i].solveSum));
            this.noSolveSum.push(Number(res.data[i].noSolveSum));
          }
          this.yhtjFun(this.yhCityName, this.yhCityId, this.sum, this.solveSum, this.noSolveSum);
        });
      },
      xctjFun(xcCityName, xcCityId, xctjNum) {
        let _this = this;
        let bar = this.$echarts.init(document.getElementById("xcbar"));
        let jianju = 80;

        bar.on('click', function(value) {
          // console.log(value)
          let currentObject = [];
          for (let i = 0; i < xcCityId.length; i++) {
            if (value.name == xcCityId[i].name) {
              currentObject.push({
                code: xcCityId[i].code,
                sectionName: value.seriesName
              });
            }
          }
          _this.$emit("xcClickNames", currentObject);
          _this.$emit("xcDialogVisibles", true);
        });

        let option = {
          animation: true,
          // tooltip: {
          //   trigger: 'axis',
          //   axisPointer: { // 坐标轴指示器，坐标轴触发有效
          //     type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          //   }
          // },
          grid: {
            top: "5%",
            bottom: "20%",
            right: "5%"
          },
          xAxis: {
            data: xcCityName,
            axisLine: {
              show: false //隐藏X轴轴线
            },
            axisTick: {
              show: false //隐藏X轴轴线
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "rgba(77, 128, 254, 0.2)",
                width: 2
              }
            },
            axisLabel: {
              show: true,
              margin: 14,
              fontSize: 14,
              textStyle: {
                color: "#fff" //X轴文字颜色
              }
            }
          },
          yAxis: [{
            type: "value",
            gridIndex: 0,
            min: 0,
            max: 100,
            interval: 25,
            // splitNumber: 4,
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(77, 128, 254, 0.2)",
                width: 2
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(77, 128, 254, 0.2)"
              }
            },
            axisLabel: {
              show: true,
              margin: 14,
              fontSize: 12,
              textStyle: {
                color: "#ccc"
              }
            }
          }],
          series: [{
              "name": "",
              type: 'pictorialBar',
              symbolSize: [0, 0],
              symbolOffset: [0, 0],
              symbolPosition: 'end',
              z: 12,
              "label": {
                "normal": {
                  "show": true,
                  "position": "top",
                  // "formatter": "{c}%"
                  fontSize: 15,
                  fontWeight: 'bold',
                  color: '#34DCFF'
                }
              },
              color: "#2DB1EF",
              data: xctjNum,
            },
            {
              name: "设备在线率",
              type: "bar",
              barWidth: 16,
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "rgba(146, 225, 255, 1)"
                    },
                    {
                      offset: 1,
                      color: "rgba(0, 151, 251, 1)"
                    }
                  ])
                }
              },
              data: xctjNum,
              z: 10,
              zlevel: 0
            },
            {
              // 分隔
              type: "pictorialBar",
              itemStyle: {
                normal: {
                  color: "#0F375F"
                }
              },
              symbolRepeat: "fixed",
              symbolMargin: 6,
              symbol: "rect",
              symbolClip: true,
              symbolSize: [18, 2],
              symbolPosition: "start",
              symbolOffset: [1, 1],
              data: xctjNum,
              width: 2,
              z: 0,
              zlevel: 1
            },
          ],
          dataZoom: [{
            type: "slider", //slider表示有滑动块的，
            show: true,
            zoomLock: true,
            left: 'center',
            bottom: '3%',
            height: '15',
            xAxisIndex: [0], //表示x轴折叠
            start: 1, //数据窗口范围的起始百分比,表示1%
            end: jianju, //数据窗口范围的结束百分比,表示35%坐标
            textStyle: {
              color: "#ccc",
              // fontWeight: "bold",
              fontSize: 12,
            },
          }]
        };
        bar.clear();
        bar.setOption(option);
      },

      yhtjFun(yhCityName, yhCityId, sum, solveSum, noSolveSum) {
        let _this = this;
        let bar = this.$echarts.init(document.getElementById("yhbar"));

        bar.on('click', function(value) {
          // console.log(value)
          let currentObject = [];
          for (let i = 0; i < yhCityId.length; i++) {
            if (value.name == yhCityId[i].name) {
              currentObject.push({
                code: yhCityId[i].code,
                sectionName: value.seriesName
              });
            }
          }
          _this.$emit("yhClickNames", currentObject);
          _this.$emit("yhDialogVisibles", true);
        });

        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '2%',
            right: '4%',
            bottom: '14%',
            top: '16%',
            containLabel: true
          },
          legend: {
            data: ['隐患数', '已整改', '未整改'],
            // right: 'center',
            top: 12,
            textStyle: {
              color: "#fff"
            },
            itemWidth: 12,
            itemHeight: 10,
            itemGap: 35
          },
          xAxis: {
            type: 'category',
            data: yhCityName,
            axisLine: {
              lineStyle: {
                color: 'white'
              }
            },
            axisLabel: {
              textStyle: {
                fontFamily: 'Microsoft YaHei'
              }
            },
          },
          yAxis: {
            type: 'value',
            minInterval: 1,
            // max: '1200',
            axisLine: {
              show: false,
              lineStyle: {
                color: 'white'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.3)'
              }
            },
            axisLabel: {}
          },
          dataZoom: [{
            type: "slider", //slider表示有滑动块的，
            show: true,
            zoomLock: true,
            left: 'center',
            bottom: '3%',
            height: '15',
            xAxisIndex: [0], //表示x轴折叠
            start: 1, //数据窗口范围的起始百分比,表示1%
            end: 80, //数据窗口范围的结束百分比,表示35%坐标
            textStyle: {
              color: "#ccc",
              // fontWeight: "bold",
              fontSize: 12,
            },
          }],
          series: [{
              name: '隐患数',
              type: 'bar',
              barWidth: '15%',
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#00AAFF ",
                    },
                    {
                      offset: 1,
                      color: "#00AAFF",
                    },
                  ]),
                  barBorderRadius: 12,
                },
              },
              data: sum
            },
            {
              name: '已整改',
              type: 'bar',
              barWidth: '15%',
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#1CEA58",
                    },
                    {
                      offset: 1,
                      color: "#1CEA58",
                    },
                  ]),
                  barBorderRadius: 11,
                }

              },
              data: solveSum
            },
            {
              name: '未整改',
              type: 'bar',
              barWidth: '15%',
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#FFE557",
                    },
                    {
                      offset: 1,
                      color: "#FFE557",
                    },
                  ]),
                  barBorderRadius: 11,
                }
              },
              data: noSolveSum
            }
          ]
        };
        bar.clear();
        bar.setOption(option);
      },
    },
  };
</script>

<style scoped>
  .totalPie,
  .zrrlist {
    width: 100%;
    height: 395px;
    background: url(../../common/images/contentborder.png) no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;
  }

  .zrrlist {
    margin-top: 10px;
  }

  .Piebar {
    width: 96%;
    height: 340px;
    margin-left: 2%;
    margin-top: 1%;
  }
</style>
